import PreviewTravel from './PreviewTravel';
export default PreviewTravel;